import { UserAccessLevel } from 'types/user';

export const hasUserS4cRole = (userLevel: UserAccessLevel | null) =>
  userLevel === UserAccessLevel.Support || userLevel === UserAccessLevel.Admin || userLevel === UserAccessLevel.SuperAdmin;
